import React from 'react';

interface PlugDLogoProps {
  size?: number;
  className?: string;
}

const PlugDLogo: React.FC<PlugDLogoProps> = ({ size = 40, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
    className={className}
  >
    <defs>
      <linearGradient id="plugd-bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#34d399" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
    <rect width="512" height="512" rx="108" fill="url(#plugd-bg)" />
    {/* Center hub */}
    <circle cx="256" cy="256" r="64" fill="#fff" />
    {/* Spokes */}
    <line x1="256" y1="192" x2="256" y2="96" stroke="#fff" strokeWidth="28" strokeLinecap="round" />
    <line x1="312" y1="220" x2="380" y2="148" stroke="#fff" strokeWidth="28" strokeLinecap="round" />
    <line x1="320" y1="256" x2="416" y2="256" stroke="#fff" strokeWidth="28" strokeLinecap="round" />
    <line x1="312" y1="292" x2="380" y2="364" stroke="#fff" strokeWidth="28" strokeLinecap="round" />
    <line x1="200" y1="292" x2="132" y2="364" stroke="#fff" strokeWidth="28" strokeLinecap="round" />
    <line x1="192" y1="256" x2="96" y2="256" stroke="#fff" strokeWidth="28" strokeLinecap="round" />
    {/* Outer nodes */}
    <circle cx="256" cy="80" r="24" fill="#fff" />
    <circle cx="392" cy="136" r="24" fill="#fff" />
    <circle cx="428" cy="256" r="24" fill="#fff" />
    <circle cx="392" cy="376" r="24" fill="#fff" />
    <circle cx="120" cy="376" r="24" fill="#fff" />
    <circle cx="84" cy="256" r="24" fill="#fff" />
    {/* Inner accent */}
    <circle cx="256" cy="256" r="20" fill="url(#plugd-bg)" />
  </svg>
);

export default PlugDLogo;
